import React, { useContext, useEffect, useState } from 'react'
import { useTheme, useMediaQuery } from '@mui/material'
import Header from '../../components/Header/Header'
import NavBar from '../../components/NavBar/NavBar'
import Filters from '../../components/Filters/Filters'
import Coupons from '../../components/Coupons/Coupons'
import { useLocation, useParams } from 'react-router-dom'
import { SlugContext } from '../../context/SlugContext'
import { CouponsContext } from '../../context/CouponsContext'
import Footer from '../../components/Footer/Footer'
import CouponsPagination from '../../components/CouponsPagination/CouponsPagination'
import useCouponData from '../../hooks/useCouponData'
import useUserData from '../../hooks/useUserData'
import useStoreCategoryData from '../../hooks/useStoreCategoryData'
import LoadingErrorWrapper from '../../components/Loading/Loading'
import useStoreData from '../../hooks/useStoreData'
import { Helmet } from 'react-helmet-async';
import { pushData } from '../../utils/dataLayer';
const Default = ({slug}) => {

  const { setSlug } = useContext(SlugContext);
  const { setCoupons } = useContext(CouponsContext);


  // const { slug } = useParams();
  const location = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (slug) setSlug(slug)
    // setSlug(slug);
  }, [slug, setSlug]);


  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");
  const page = queryParams.get("page");
  const category = queryParams.get("category");
  const type = queryParams.get("type");

  const { coupons, loadingCoupon, errorCoupon, totalPages } = useCouponData({
    slug,
    name,
    page,
    category,
    type
  });

  const { categorie, loadingCategorie, errorCategorie } = useStoreCategoryData({slug})

  const { store, loadingStore, errorStore } = useStoreData({slug})

  const { user, loadingUser, errorUser } = useUserData()

  useEffect(() => {
    setCoupons(coupons);
  }, [coupons, setCoupons]);

  
  const meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];

  const dataAtual = new Date();
  const mesAtual = meses[dataAtual.getMonth()];
  const anoAtual = dataAtual.getFullYear();

  const isStore = !categorie && !!store?.slug;

  const storeName = categorie?.name || store?.name;

  const metaTitle = storeName
    // categorie?.metadata?.title ||
    // store?.metadata?.title ||
    ? `Cupom ${storeName} | Descontos e Cashback - ${mesAtual} ${anoAtual}`
    : `Meu Cupom | Cupom de Desconto, Ofertas e Cashback`;


  useEffect(() => {
    if (categorie) pushData({ category: categorie });
    else if (store?.slug) pushData({ store });
  }, [categorie, store]);

  return (
    <>
    <Helmet>

        <title>
          {metaTitle}
        </title>

    </Helmet>
      <LoadingErrorWrapper loading={loadingCoupon || loadingCategorie || loadingUser || loadingStore}>
        <div>
          <NavBar 
          hotArea= {categorie? categorie: store}
          ></NavBar>
          <Header
          hotArea= {categorie? categorie: store}
          isStore={isStore}
          ></Header>
          <Filters 
          slug={slug}
          ></Filters>
          <Coupons 
          categorie= {categorie? categorie: store}
          pagination={isMobile ? <CouponsPagination totalPages={coupons.totalPages} /> : null}
          genericCoupons={coupons}
          ></Coupons>
          {!isMobile && <CouponsPagination couponProp={coupons.data} totalPages={totalPages} />}
          <Footer></Footer>
        </div>
      </LoadingErrorWrapper>
    </>

  )
}

export default Default